import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ClientSignatureType } from '../../../../../core';

@JsonConverter
export class ClientSignatureTypeAdapter implements JsonCustomConvert<ClientSignatureType | undefined> {
    serialize(signatureType: ClientSignatureType): any | undefined {
        return signatureType ? String(signatureType) : undefined;
    }

    deserialize(signatureType: any): ClientSignatureType | undefined {
        switch (signatureType) {
            case 'handwritten_signature':
                return ClientSignatureType.HANDWRITTEN;
            case 'in_person_electronic_signature':
                return ClientSignatureType.IN_PERSON_ELECTRONIC;
            case 'remote_electronic_signature':
                return ClientSignatureType.REMOTE_ELECTRONIC;
            default:
                return undefined;
        }
    }
}
